import type { SimView } from "../../core/simView";
import {
  RELATION_ENEMY_RGB,
  RELATION_FRIEND_RGB,
  RELATION_SELECT_RGB,
  rgba,
} from "../../render/relationColors";
import type { DrawContext, LensPlugin } from "../types";

function drawLink(
  g: DrawContext,
  i: number,
  j: number,
  color: string,
  width: number,
): void {
  const { ctx, screenX, screenY } = g;
  ctx.strokeStyle = color;
  ctx.lineWidth = width;
  ctx.lineCap = "round";
  ctx.beginPath();
  ctx.moveTo(screenX[i]!, screenY[i]!);
  ctx.lineTo(screenX[j]!, screenY[j]!);
  ctx.stroke();
}

function drawHalo(g: DrawContext, i: number, color: string, r: number): void {
  const { ctx, screenX, screenY } = g;
  ctx.strokeStyle = color;
  ctx.lineWidth = 2.25;
  ctx.beginPath();
  ctx.arc(screenX[i]!, screenY[i]!, r, 0, Math.PI * 2);
  ctx.stroke();
}

/** Highlight selected particle + its friend (blue) / enemy (amber). */
export const selectionLens: LensPlugin = {
  id: "selection",
  label: "Selection highlight",
  tier: "basic",
  description:
    "Halo and links for the clicked particle — blue friend, amber enemy",
  always: true,
  enabled: (r) => (r.selectedIndex ?? -1) >= 0,
  draw(view: SimView, g: DrawContext) {
    const i = g.render.selectedIndex ?? -1;
    if (i < 0 || i >= view.n) return;
    const { friends, enemies } = view;
    const f = friends[i]!;
    const e = enemies[i]!;
    // Enemy under friend so both stay readable if they share a target
    drawLink(g, i, e, rgba(RELATION_ENEMY_RGB, 0.95), 2.4);
    drawLink(g, i, f, rgba(RELATION_FRIEND_RGB, 0.98), 2.6);
    // Double ring on selected = “source” / focus (works for inspect + rewire)
    drawHalo(g, i, rgba(RELATION_SELECT_RGB, 0.55), 11);
    drawHalo(g, i, rgba(RELATION_SELECT_RGB, 0.95), 8);
    drawHalo(g, f, rgba(RELATION_FRIEND_RGB, 0.95), 6);
    drawHalo(g, e, rgba(RELATION_ENEMY_RGB, 0.95), 6);
  },
};
